"use strict";

if (!require("./is-implemented")()) {
	Object.defineProperty(require("ext/global-this"), "Symbol", {
		value: require("./polyfill"),
		configurable: true,
		enumerable: false,
		writable: true
	});
}



//////////////////
// WEBPACK FOOTER
// ./~/es6-symbol/implement.js
// module id = 683
// module chunks = 0